module.exports = __webpack_public_path__ + "static/media/pizarra_fina.a3b3bceb.jpg";